"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const RtcConnectionsStore_1 = __importDefault(require("./RtcConnectionsStore"));
const service_1 = __importDefault(require("../../services/p2p/service"));
class RtcConnectionsHandler {
    constructor() {
        this.lastUpdated = null;
        this.setupMissingConnections = (users) => __awaiter(this, void 0, void 0, function* () {
            const createOfferPromises = users
                .filter(u => !RtcConnectionsStore_1.default.exists(u))
                .map(this.createOffer);
            if (createOfferPromises.length) {
                const offers = yield Promise.all(createOfferPromises);
                yield service_1.default.addOffers({
                    offers
                });
            }
        });
        this.getConnections = () => __awaiter(this, void 0, void 0, function* () {
            const response = yield service_1.default.getConnectionDetails(this.lastUpdated);
            if (response.kind !== "success") {
                return 0;
            }
            if (response.connections.length) {
                yield this.handleRemoteConnectionDetails(response.connections);
            }
            this.lastUpdated = response.timestamp;
            return response.connections.length;
        });
        this.sendMessage = (users, data) => {
            for (const user of users) {
                const connection = RtcConnectionsStore_1.default.get(user);
                if (connection && connection.isConnected()) {
                    connection.sendMessage(data);
                }
            }
        };
        this.createOffer = (user) => __awaiter(this, void 0, void 0, function* () {
            const connection = RtcConnectionsStore_1.default.create(user);
            return yield connection.createOffer();
        });
        this.handleRemoteConnectionDetails = (connectionDetails) => __awaiter(this, void 0, void 0, function* () {
            const offers = [];
            const handleRemoteAnswerPromises = [];
            for (const cd of connectionDetails) {
                if (cd.kind === "offer") {
                    offers.push(cd);
                }
                else {
                    handleRemoteAnswerPromises.push(this.handleRemoteAnswer(cd));
                }
            }
            if (offers.length) {
                const createAnswerPromises = offers.map(this.createAnswer);
                const answers = yield Promise.all(createAnswerPromises);
                yield service_1.default.addAnswers({
                    answers
                });
            }
            yield Promise.all(handleRemoteAnswerPromises);
        });
        this.createAnswer = (offer) => __awaiter(this, void 0, void 0, function* () {
            let rtcConnection = RtcConnectionsStore_1.default.get(offer.userId);
            if (rtcConnection) {
                RtcConnectionsStore_1.default.remove(offer.userId);
            }
            rtcConnection = RtcConnectionsStore_1.default.create(offer.userId);
            return yield rtcConnection.answerRemoteOffer(offer);
        });
        this.handleRemoteAnswer = (answer) => __awaiter(this, void 0, void 0, function* () {
            const rtcConnection = RtcConnectionsStore_1.default.get(answer.userId);
            if (rtcConnection) {
                yield rtcConnection.addRemoteAnswer(answer);
            }
        });
    }
}
const handler = new RtcConnectionsHandler();
exports.default = handler;
